// Delivery banner cards (shown when a non-local country is selected):
//   truck -> deliver to a (different) address  -> enable "different_address"
//   store -> pick up in store                  -> disable "different_address",
//            auto-select store pickup in step 2 and open the find-store modal.
//
// Names are prefixed to avoid collisions with other concatenated component scripts.

const deliveryBannerTypeAddress = 'truck';
const deliveryBannerTypeStore = 'store';

const getDeliveryBannerDifferentAddressInput = () => document.querySelector('#different_address');
const getDeliveryBannerStorePickupTrigger = () =>
	document.querySelector('[data-modal-trigger][data-id="find-store-modal"]');

const deliveryBannerSetDifferentAddress = (active) => {
	const input = getDeliveryBannerDifferentAddressInput();
	if (!input) {
		return;
	}

	input.disabled = !active;

	if (input.checked !== active) {
		input.checked = active;
		input.dispatchEvent(new Event('change', { bubbles: true }));
	}
};

const deliveryBannerSetOnlyStorePickup = (onlyStorePickup) => {
	document.querySelectorAll('input[name="delivery"]').forEach((input) => {
		const card = input.closest('.purchase-process-dropdown');
		const isStorePickup = !!input.closest('.store-pickup-item');

		if (!onlyStorePickup) {
			card?.classList.remove('hide');
			return;
		}

		card?.classList.toggle('hide', !isStorePickup);

		if (isStorePickup && !input.checked) {
			input.checked = true;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
	});
};

const deliveryBannerOpenFindStoreModal = () => {
	const trigger = getDeliveryBannerStorePickupTrigger();
	if (trigger) {
		toggleModal(trigger, true);
	}
};

// The find-store modal is rendered inside step 2, which is `hidden` until the
// buyer advances. Move it up to the `[data-modal-parent]` container so it can
// be opened from step 1 too.
const deliveryBannerRelocateFindStoreModal = () => {
	const modal = document.querySelector('[data-modal][data-id="find-store-modal"]');
	const parent = document.querySelector('.purchase-process[data-modal-parent]');
	if (modal && parent && modal.parentElement !== parent) {
		parent.appendChild(modal);
	}
};

const deliveryBannerHandleChange = (input) => {
	if (!input.checked) {
		return;
	}

	const type = input.dataset.deliveryType;

	if (type === deliveryBannerTypeStore) {
		deliveryBannerSetDifferentAddress(false);
		deliveryBannerSetOnlyStorePickup(true);
		deliveryBannerOpenFindStoreModal();
	} else if (type === deliveryBannerTypeAddress) {
		deliveryBannerSetDifferentAddress(true);
		deliveryBannerSetOnlyStorePickup(false);
	}
};

deliveryBannerRelocateFindStoreModal();

document.querySelectorAll('input[name="address_country_delivery_banner"]').forEach((input) => {
	input.addEventListener('change', () => deliveryBannerHandleChange(input));
});
